import { render, staticRenderFns } from "./inc_zadmin_head.vue?vue&type=template&id=bcfe551a&"
import script from "./inc_zadmin_head.vue?vue&type=script&lang=js&"
export * from "./inc_zadmin_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports